import JianduPicker from './JianduPicker.vue'
export default JianduPicker